import createWsAction from 'utils/create-ws-action'

// ------------------------------------
// Action Types
// ------------------------------------
export const FACECHECKIN_LIST = 'unifi.FACECHECKIN_LIST'

// ------------------------------------
// Action Creators
// ------------------------------------
export const listFaceCheckins = createWsAction({
    type: FACECHECKIN_LIST,
    messageType: 'thermal.face.list-face-checkins',
    selectorKey: 'facecheckinsList',
    fields: ['clientId', 'siteId']
})

export default null



// WEBPACK FOOTER //
// ./src/redux/modules/model/face.js